import "./Sidnavbar.scss";

import { IMenuItem } from "./ISidnavbar";
import { SvgIcon } from "@mui/material";
import { ReactComponent as Dashboard } from '../../Assets/Images/Dashboard.svg';
import { ReactComponent as Master } from '../../Assets/Images/Master.svg';
import { ReactComponent as vehicle } from '../../Assets/Images/Tower.svg';
import RoomIcon from '@mui/icons-material/Room';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import Person3Icon from '@mui/icons-material/Person3';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import { reload } from "firebase/auth";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
// managment

/*    dummy menu     */
export const menu: { [key: string]: IMenuItem[] } = {
  Dashboard: [
    {
      icon: (
        <SvgIcon
          className="svg_icon"
          component={Dashboard}
          inheritViewBox
        />
      ),
      title: "Dashboard",
      to: "dashboard",
      permissions: {
        add: true,
        view: true,
        edit: true,
        delete: true,
      },
    },

    {
      icon: (
        <SvgIcon
          className="svg_icon"
          component={RoomIcon}
          inheritViewBox
        />
      ),
      title: "Location List",
      to: "location",
      permissions: {
        add: true,
        view: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: (
        <SvgIcon
          className="svg_icon"
          component={DirectionsCarIcon}
          inheritViewBox
        />
      ),
      title: "Vehicle List",
      to: "vehicle",
      permissions: {
        add: true,
        view: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: (
        <SvgIcon
          className="svg_icon"
          component={PriceCheckIcon}
          inheritViewBox
        />
      ),
      title: "Subscription List",
      to: "Subscription",
      permissions: {
        add: true,
        view: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: (
        <SvgIcon
          className="svg_icon"
          component={LocalTaxiIcon}
          inheritViewBox
        />
      ),
      title: "Membership Vehicles",
      to: "MembershipVehicles",
      permissions: {
        add: true,
        view: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: (
        <SvgIcon
          className="svg_icon"
          component={MonetizationOnIcon}
          inheritViewBox
        />
      ),
      title: "Sales List",
      to: "Sales",
      permissions: {
        add: true,
        view: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: (
        <SvgIcon
          className="svg_icon"
          component={Person3Icon}
          inheritViewBox
        />
      ),
      title: "Owner List",
      to: "owner",
      permissions: {
        add: true,
        view: true,
        edit: true,
        delete: true,
      },
    },

    {
      icon: (
        <SvgIcon
          className="svg_icon"
          component={Master}
          inheritViewBox
        />
      ),
      title: "User List",
      to: "users",
      permissions: {
        add: true,
        view: true,
        edit: true,
        delete: true,
      },
    },
  ],
};

export const menu1: { [key: string]: IMenuItem[] } = {
  Dashboard: [
    {
      icon: (
        <SvgIcon
          className="svg_icon"
          component={Dashboard}
          inheritViewBox
        />
      ),
      title: "Dashboard",
      to: "dashboard",
      permissions: {
        add: true,
        view: true,
        edit: true,
        delete: true,
      },
    },

    {
      icon: (
        <SvgIcon
          className="svg_icon"
          component={RoomIcon}
          inheritViewBox
        />
      ),
      title: "Location List",
      to: "location",
      permissions: {
        add: true,
        view: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: (
        <SvgIcon
          className="svg_icon"
          component={PriceCheckIcon}
          inheritViewBox
        />
      ),
      title: "Subscription List",
      to: "Subscription",
      permissions: {
        add: true,
        view: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: (
        <SvgIcon
          className="svg_icon"
          component={MonetizationOnIcon}
          inheritViewBox
        />
      ),
      title: "Sales List",
      to: "Sales",
      permissions: {
        add: true,
        view: true,
        edit: true,
        delete: true,
      },
    },
  ],
};
export const skipedMenu = [
  "/invalid-token",
  "/location/tariff",
  "/location/views",
  "/location/slot",
  "/location/pricings",
  "/location/designations",
  "/location/SpaceTypes",
  "/location/locAds",
  "/location/locAdsHistory",
  "/location/membershipVehicle",
  "/location/designations/membershipVehicle",
  "/location/packageManagement",
  "/location/designations/packageManagement",
];
  